var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1206_",
    d: "M21.8 6.75H20.3V4.5C20.3 3.67275 19.6273 3 18.8 3H4.92505C3.47755 3 2.30005 4.1775 2.30005 5.625V19.125C2.30005 20.5725 3.47755 21.75 4.92505 21.75H21.8C22.6273 21.75 23.3 21.0772 23.3 20.25C23.3 15.7028 23.3 12.279 23.3 8.25C23.3 7.42275 22.6273 6.75 21.8 6.75ZM4.92505 4.5H18.8V6.75H4.92505C4.3048 6.75 3.80005 6.24525 3.80005 5.625C3.80005 5.00475 4.3048 4.5 4.92505 4.5ZM21.8 15.75H18.8C17.9728 15.75 17.3 15.0773 17.3 14.25C17.3 13.4227 17.9728 12.75 18.8 12.75H21.8V15.75ZM21.8 11.25H18.8C17.1455 11.25 15.8 12.5955 15.8 14.25C15.8 15.9045 17.1455 17.25 18.8 17.25H21.8V20.25H4.92505C4.3048 20.25 3.80005 19.7453 3.80005 19.125V7.9965C4.1413 8.15925 4.5223 8.25 4.92505 8.25H21.8V11.25Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon_wallet.ecd6c98499bab6a9d1b9a41f3ee57439.svg";
export { ForwardRef as ReactComponent };